<template>
  <div
    class="wrap"
    :class="{ isEnglish: $isEnglish }"
  >
    <a-form-item
      v-if="data"
      :label="data.fieldname"
      class="address"
    >
      <div
        v-decorator="[
          fieldkey,
          {
            initialValue: fieldvalue,
            trigger: [],
            rules: [
              {
                required: isneeded,
                message: ' '
              },
              {
                validator: checkValue
              }
            ]
          }
        ]"
        class="code-line"
      >
        <linkage
          :default-value="routes"
          :get-data="getData"
          :search-data="searchData"
          :report-search="reportSearch"
          :has-child="item => item.haschildren !== 0"
          @change="completeHandle"
        >
          <div class="select-box">
            <a-input
              read-only
              :value="codeDesc"
              :placeholder="placeholder"
              :show-search="showSearch"
            />
            <i
              slot="icon"
              class="arrow-icon iconfont iconicon-test19"
            />
          </div>
        </linkage>
        <i
          v-if="codeDesc"
          class="iconfont iconditu address-map"
          @click="mapVisible = true"
        />
        <MapModal
          v-if="mapVisible && codeDesc"
          :visible.sync="mapVisible"
          :address="codeDesc"
          :last-code="lastCode"
          :fieldkey="data.fieldkey"
          :fieldtype="data.fieldtype"
        />
      </div>
    </a-form-item>
    <a-input
      v-if="enableinput"
      :value="fieldvalue.address"
      :placeholder="addressPlaceholder"
      class="address-input"
      @change="inputChangeHandle"
    />
  </div>
</template>

<script>
import Linkage from '@/components/pc/Linkage'
import MapModal from '@/components/pc/map/MapModal'
import { getArea, SearchArea, addAreaSearchLog } from '@/services/index'

export default {
  name: 'Area',
  inject: ['myForm'],
  components: {
    Linkage,
    MapModal
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routes: [],
      mapVisible: false,
      fieldvalue: this.data.fieldvalue || {}
    }
  },
  computed: {
    codeDesc () {
      return this.routes.map(item => item.name).join(' / ')
    },
    lastCode () {
      let len = this.routes.length
      let lastCodeItem = this.routes[len - 1]
      return lastCodeItem.code
    },
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    },
    enableinput () {
      const { enableinput = true } = this.fieldconfig
      return enableinput
    },
    showSearch () {
      const { showSearch = true } = this.fieldconfig
      return showSearch
    },
    fieldkey () {
      return this.data.fieldkey
    },
    isneeded () {
      return this.data.isneeded === 1
    },
    addressPlaceholder () {
      return this.$t('message["813"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.routes = []
        this.init()
      },
      // deep: true,
      immediate: true
    }
  },
  methods: {
    init () {
      const { fieldvalue = {} } = this.data
      // fix-start: 当fieldvalue为空时后端返回的是[],因此需要下面特殊处理依稀
      const value = {
        code: fieldvalue.code || {},
        address: fieldvalue.address || ''
      }
      this.data.fieldvalue = value
      // fix-end
      const { code = {} } = this.data.fieldvalue
      this.routes = Object.keys(code).map(key => {
        return {
          code: key,
          name: code[key]
        }
      })
    },
    checkValue (rule, value = {}, callback) {
      const { isneeded } = this
      if (!isneeded) {
        callback()
      } else {
        const { code = {} } = value
        const { length } = Object.keys(code)

        if (length) {
          callback()
        } else {
          callback(new Error(`${this.$t('message["855"]')}${this.data.fieldname}`))
        }
      }
    },
    validatedCallback (err, values) {
      if (!err) {
        this.$emit('change', this.fieldvalue)
      }
    },
    inputChangeHandle (e) {
      const { fieldkey, fieldvalue } = this
      let val = e.target.value
      // fieldvalue.address = val.trim()
      fieldvalue.address = val
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    completeHandle (routes) {
      const { fieldkey, fieldvalue } = this
      this.routes = routes
      const codes = {}
      routes.forEach((item) => {
        const { code, name } = item
        codes[code] = name
      })
      fieldvalue.code = codes
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },

    async getData ({ level, data }) {
      const chain = await getArea()
      const params = {}
      if (data) {
        params.code = data.code
        params.fieldkey = this.data.fieldkey
      } else {
        params.fieldkey = this.data.fieldkey
      }
      return new Promise(async (resolve, reject) => {
        await chain
          .params(params)
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword }) {
      const chain = await SearchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: this.data.fieldkey
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  margin-bottom: 24px;
}
.code-line {
  position: relative;
  width: 320px;
  .address-map {
    position: absolute;
    top: 0;
    left: 334px;
    color: $gray3;
    font-style: normal;
    cursor: pointer;
  }
}
.select-box {
  position: relative;
  width: 320px;
  .arrow-icon {
    position: absolute;
    right: 8px;
    color: $gray3;
  }
}
.address-input {
  margin-left: 140px;
}
.isEnglish .address-input {
  margin-left: 200px;
}
</style>
<style lang="scss">
.area-pover {
  width: 320px;
  padding-top: 0;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
}
</style>
